import React from 'react';
//import {useSelector} from 'react-redux';
//import * as Scroll from 'react-scroll';
//import { animateScroll as scroll } from 'react-scroll';
import { HashLink as Link } from 'react-router-hash-link';

import classes from './Landingpage.module.scss';
//import About from '../About/About';
//import Projects from '../Projects/Projects';
//import Contacts from '../Contacts/Contacts';

import Arrow from  '../assets/arrow.svg';
import Mail from '../assets/Social/mail2.svg';
import Github from '../assets/Social/github1.svg';
import Linkedin from '../assets/Social/linkedin.svg';
import Phone from '../assets/Social/phone.svg';
//import { scrollMore } from 'react-scroll/modules/mixins/animate-scroll';

const LandingPage = () => { 

    //const darkMode = useSelector(state => state.darkMode)

    /* let mode = null;

    if(darkMode){
        mode = classes.LandingPageDark
    } else {
        mode = classes.LandingPageLight
    } */

    return ( 
        <div className={classes.ScrollSnap} id="home">
            <div className={classes.Banner}>
                <section className={classes.Heading}>


                    {/* <svg viewBox="0 0 960 300">
                    <symbol id="s-text">
                        <text text-anchor="middle" x="50%" y="80%">Montserrat</text>
                    </symbol>

                    <g class = "g-ants">
                        <use xlinkHref="#s-text" class="text-copy"></use>
                        <use xlinkHref="#s-text" class="text-copy"></use>
                        <use xlinkHref="#s-text" class="text-copy"></use>
                        <use xlinkHref="#s-text" class="text-copy"></use>
                        <use xlinkHref="#s-text" class="text-copy"></use>
                    </g>
                    </svg> */}


                    <p className={classes.Hello}>Hi there! My Name is ...</p>
                    <h1 className={classes.Name}>Parth <br />Pakhare</h1>
                    <p className={classes.Desc}>Web Developer & Designer</p>


                </section>
                <section className={classes.Scroll}><p>SCROLL</p><img src={Arrow} alt="arrow"/></section>
                <section className={classes.Social}>
                    <div className={classes.Container} >
                        <Link to ="#contact" smooth>
                            <img src={Mail} alt="Mail"/>
                            <img src={Linkedin} alt="LinkedIn"/>
                            <img src={Github} alt="Github"/>
                            <img src={Phone} alt="Phone"/>
                        </Link>

                    </div>
                </section>
                
                {/* <img src={Arrow}/> */}
            </div>
            {/* <About />
            <Projects />
            <Contacts /> */}
        </div>
    )
}

export default LandingPage;